// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BootstrapIcon, BootstrapImage, SizeMap } from '../../../dsl/front';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let ImageWithCaption = class ImageWithCaption extends Vue {
    constructor() {
        super(...arguments);
        this.size = SizeMap;
    }
    /**
     * Shorthand for `this.image.author` with some additional security checks.
     */
    get author() {
        if (this.hideAuthor) {
            return;
        }
        if (this.image === null ||
            typeof this.image.author !== 'string' ||
            this.image.author.length === 0) {
            return;
        }
        return this.image.author;
    }
    /**
     * Shorthand for `this.image.caption` with some additional security checks.
     */
    get caption() {
        if (this.overridenCaption !== undefined) {
            return this.overridenCaption;
        }
        if (this.hideDescription) {
            return;
        }
        if (this.image === null ||
            typeof this.image.caption !== 'string' ||
            this.image.caption.length === 0) {
            return;
        }
        return this.image.caption;
    }
    /**
     * Emits click event on figure
     */
    onImageClick() {
        this.$emit('click');
    }
};
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: false
    })
], ImageWithCaption.prototype, "canPreview", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: false
    })
], ImageWithCaption.prototype, "hideAuthor", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: false
    })
], ImageWithCaption.prototype, "hideDescription", void 0);
__decorate([
    Prop({
        type: Object,
        required: false,
        default: null
    })
], ImageWithCaption.prototype, "image", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: false
    })
], ImageWithCaption.prototype, "isLazy", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: false
    })
], ImageWithCaption.prototype, "fetchPriority", void 0);
__decorate([
    Prop({
        type: String,
        required: false
    })
], ImageWithCaption.prototype, "overridenCaption", void 0);
ImageWithCaption = __decorate([
    Component({
        name: 'ImageWithCaption',
        components: {
            BootstrapImage,
            BootstrapIcon
        },
        template: `
    <figure v-if="image" class="image-with-caption" @click="onImageClick">

    <!-- Image itself -->
    <div :class="{'preview-image-container' : canPreview}">
      <div class="image-with-caption__image-wrapper">
        <BootstrapImage
          v-bind="{ ...image, isLazy, fullscreen:null, alt:(image.alt)?image.alt:image.caption, caption:null, fetchpriority:(fetchPriority)?'high':null }"
          class="image-with-caption__image"/>
        <slot/>
      </div>
      <BootstrapIcon v-if="canPreview" class="preview-image-icon" :size="size.Large" :name="'search'"/>
    </div>

    <figcaption v-if="caption || author" class="image-with-caption__caption">
      <!-- Caption -->
      <template v-if="caption">
        {{ caption }}
      </template>

      <!-- Author -->
      <cite v-if="author">
        <br v-if="caption"/>
        {{ $t('_.photo-by') }}. {{ author }}
      </cite>
    </figcaption>
    </figure>
  `
    })
], ImageWithCaption);
export { ImageWithCaption };
